import { render, staticRenderFns } from "./UserInput.vue?vue&type=template&id=60f77c7c&scoped=true&"
import script from "./UserInput.vue?vue&type=script&lang=js&"
export * from "./UserInput.vue?vue&type=script&lang=js&"
import style0 from "./UserInput.vue?vue&type=style&index=0&id=60f77c7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f77c7c",
  null
  
)

export default component.exports